import axios from 'axios';
// import { User } from '@/classes';
// import { IAuthMessageEvent, ILoginData } from '@/types';
// import UtilService from '@/services/util';
// import router from '../router';
// import { HttpRepository } from '@/repositories/http-repository';
// import userRepository from '@/repositories/user-repository';
// import { transformAndValidate } from 'class-transformer-validator';
import { BaseApi } from '@/modules/core/base.api';
import router from './router';
import store from './store';
import { User } from '@/modules/user/user';
import { Agency } from '@/modules/agency/agency';

class AuthenticationServiceClass extends BaseApi {
  public apiPath = 'auth';
  public user: User | null = null;

  constructor() {
    super();
    axios.interceptors.request.use((config) => {
      return config;
    }, (error) => Promise.reject(error));
    axios.interceptors.response.use((response) => response, (error) => {
      if (error.response.status === 401) {
        if (this.isAuthenticated) {
          this.user = null;
          if (router.currentRoute.name !== 'login') {
            const loginQuery = new URLSearchParams({
              redirect: router.currentRoute.fullPath,
            });

            if (error.response.data && error.response.data.code === 'ERR_EXPIRED_SESSION') {
              loginQuery.append('expired_session', '1');
            }

            router.replace('login?' + loginQuery.toString());
          }
        }
      }

      return Promise.reject(error);
    });
  }

  public get isAuthenticated(): boolean {
    return !!this.user;
  }

  public async refreshUser(): Promise<User> {
    const response = await this.api.get(this.baseUrlFor('me'));
    this.user = new User(response.data); // await transformAndValidate(User, response.data as object);
    if (this.user.agency) {
      this.user.agency = new Agency(this.user.agency);
    }
    store.commit('user', response.data);
    // userRepository.currentUser = this.user;

    return this.user;
  }

  public async getUser(): Promise<User> {
    if (!this.user) {
      return await this.refreshUser();
    } else {
      return this.user;
    }
  }

  public async login(loginData: { username: string; password: string }): Promise<void> {
    const response = await this.api.post(this.baseUrlFor('login'), loginData);
    this.user = new User(response.data);

    if (this.user.agency) {
      this.user.agency = new Agency(this.user.agency);
    }
    store.commit('user', this.user);
    // await transformAndValidate(User, response.data as object);
    // userRepository.currentUser = response.data;
  }

//   public async googleLogin() {
//     return (new Promise((resolve, reject) => {
//       let popupMsg: IAuthMessageEvent;
//       const onPopupMessage = (msg: Event) => popupMsg = msg as IAuthMessageEvent;
//       window.addEventListener('message', onPopupMessage);
//       const popup: Window | null = UtilService.popupCenter(
//         this.baseUrlFor('auth', 'google'),
//         'Google authentification', 400, 600,
//       );
//       if (popup) {
//         UtilService.onWindowClosed(popup, () => {
//           window.removeEventListener('message', onPopupMessage, false);
//           if (!popupMsg) {
//             reject(new Error('No data received for Google auth'));
//           }
//           resolve(popupMsg);
//         });
//       } else {
//         reject(new Error('Error creating login popup'));
//       }
//     }) as Promise<IAuthMessageEvent>)
//       .then((authMsg: IAuthMessageEvent) => this.user = authMsg.user);
//     // TODO HANDLE AUTH ERROR
//   }

  public async logout(): Promise<void> {
    this.user = null;
    try {
      await axios.get(this.baseUrlFor('logout'));
    } catch (_) {}

    router.replace({ name: 'login' });
  }
}

const AuthenticationService = new AuthenticationServiceClass();

export default AuthenticationService;
